import { Component, OnInit } from '@angular/core';
import { EditUsers } from '../../../models/adduser/adduser/adduser.module';
import { AddUsersService } from '../../../services/add-users.service';
import { UserService } from '../../../services/user.service';
import { GLOBAL_IMAGES } from '../../../services/global.service';
import Swal from 'sweetalert2';
import { HttpClient, HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html',
  styleUrls: ['./perfil.component.css']
})
export class PerfilComponent implements OnInit {
  editUser: EditUsers;
  editPass: EditUsers;
  loadingImage: boolean = false;
  loadingPass: boolean = false;
  loadingInfo: boolean = false;
  token;
  id;
  filedata: any;
  img: string;
  url;
  tipo: number = 0;
  show: boolean = false;
  pass_error: boolean = false;
  previewUrl: any = null;
  fileUploadProgress: string = null;
  constructor(private _adduser: AddUsersService, private _userService: UserService) {
    let user = this._userService.getIdentity();
    this.id = user.sub;
    let token = this._userService.getToken();
    this.token = token;
    this.url = GLOBAL_IMAGES.url;
    this.img = user.img;
    this.editUser = new EditUsers(user.name, user.last_name, user.email, 0, this.id, null);
    this.editPass = new EditUsers('', '', '', 0, this.id, null);
  }

  ngOnInit(): void {
  }
  fileEvent(e) {
    this.filedata = e.target.files[0];
    this.preview();
  }
  preview() {
    // Show preview 
    let mimeType = this.filedata.type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }
    let reader = new FileReader();
    reader.readAsDataURL(this.filedata);
    reader.onload = (_event) => {
      this.previewUrl = reader.result;
    }
  }
  info_form(form) {
    console.log(this.editUser);
    this.loadingInfo = true;
    this._adduser.editInfo(this.editUser, this.token).subscribe(
      response => {
        this._userService.editIdentityInfo(this.editUser.nombre, this.editUser.apellido, this.editUser.email);
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: response.message,
          showConfirmButton: false,
          timer: 1500
        });
        this.loadingInfo = false;
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      }, error => {
        console.log(<any>error);
        this.loadingInfo = false;
        let message_error = "Mensaje: " + <any>error.message + "Nombre: " + <any>error.name + "Status: " + <any>error.status + "Texto Status: " + <any>error.statusText;
        this._userService.register_error(message_error, this.token).subscribe(
          response2 => {
            Swal.fire({
              position: 'top-end',
              icon: 'warning',
              title: response2.message,
              showConfirmButton: false,
              timer: 2000
            });
          },
          error => {
            console.log(<any>error);
          }
        );
      }
    );

  }
  password() {
    this.show = !this.show;
  }
  pass_form(form) {
    console.log(this.editPass);
    this.loadingPass = true;
    if (this.editPass.nombre == this.editPass.apellido) {
      this._adduser.editPass(this.editPass, this.token).subscribe(
        response => {
          this.loadingPass = false;
          this.pass_error = false;
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: response.message,
            showConfirmButton: false,
            timer: 1500
          });
        }, error => {
          console.log(<any>error);
          this.loadingInfo = false;
          let message_error = "Mensaje: " + <any>error.message + "Nombre: " + <any>error.name + "Status: " + <any>error.status + "Texto Status: " + <any>error.statusText;
          this._userService.register_error(message_error, this.token).subscribe(
            response2 => {
              Swal.fire({
                position: 'top-end',
                icon: 'warning',
                title: response2.message,
                showConfirmButton: false,
                timer: 2000
              });
            },
            error => {
              console.log(<any>error);
            }
          );
        }
      );
    } else {
      this.loadingPass = false;
      this.pass_error = true;
    }
  }
  cambiar_imagen(form) {
    this.loadingImage = true;
    this._adduser.change_image(this.editUser, this.filedata, this.token).subscribe(
      response => {
        if (response.type === HttpEventType.UploadProgress) {
          this.fileUploadProgress = Math.round(response.loaded / response.total * 100) + '%';
          console.log(this.fileUploadProgress);
        } else if (response.type === HttpEventType.Response) {
          this.fileUploadProgress = '';
          this.editUser = new EditUsers('nombre', '', '', 0, this.id, null);
          this.loadingImage = false;
          this._userService.editIdentityImage(response.body.img);
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: response.message,
            showConfirmButton: false,
            timer: 1500
          });
          this.tipo = 3;
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        }
      },
      error => {
        console.log(error);
        let message_error = "Mensaje: " + <any>error.message + "Nombre: " + <any>error.name + "Status: " + <any>error.status + "Texto Status: " + <any>error.statusText;
        this._userService.register_error(message_error, this.token).subscribe(
          response2 => {
            Swal.fire({
              position: 'top-end',
              icon: 'warning',
              title: response2.message,
              showConfirmButton: false,
              timer: 2000
            });
          },
          error => {
            console.log(<any>error);
          }
        );
      }
    );
  }
}
